import React from 'react';
import { Tab, Nav, NavItem } from 'react-bootstrap'
import { faEnvelopeOpen } from '@fortawesome/free-regular-svg-icons';
import { faPaste } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AlButton } from '_components'
import {PdfDisplayTab, ActivityLogTab, MessageHistoryTab } from 'MessageCenter/NotesRequiringApproval'


export class NotesRequiringApprovalTabs extends React.Component {
    render() {
        return (
            <Tab.Container defaultActiveKey="note">
                <Nav variant="tabs" as="ul" className="tab_look" >
                    <NavItem as="li">
                        <Nav.Link eventKey="note"><FontAwesomeIcon icon={faPaste} /> Note</Nav.Link>
                    </NavItem>
                    <NavItem as="li">
                        <Nav.Link eventKey="activity_log"><AlButton size='extra-small' /> Activity Log</Nav.Link>
                    </NavItem>
                    <NavItem as="li">
                        <Nav.Link eventKey="message_history"><FontAwesomeIcon icon={faEnvelopeOpen} /> Message History</Nav.Link>
                    </NavItem>
                </Nav>
                <Tab.Content>
                    <Tab.Pane eventKey="note">
                        <PdfDisplayTab />
                    </Tab.Pane>
                    <Tab.Pane eventKey="activity_log">
                        <ActivityLogTab />
                    </Tab.Pane>
                    <Tab.Pane eventKey="message_history">
                        <MessageHistoryTab />
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        );
    }
}

